'use client';

import React, { PropsWithChildren, ReactNode } from 'react';
import { useRouter, useSearchParams } from 'next/navigation';
import { faSort, faSortDown, faSortUp, IconDefinition } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box } from '@mui/material';

function SortWidget({
  sortKey,
  sortType,
  children,
}: { sortKey?: string; sortType?: 'string' | 'number' } & PropsWithChildren): ReactNode {
  const searchParams = useSearchParams();
  const router = useRouter();
  const sortByName = searchParams.get('sortByName');
  const sortByOrder = searchParams.get('sortByOrder');
  let icon: IconDefinition = faSort;

  if (!sortKey) return children;

  if (sortByName === sortKey) {
    switch (sortByOrder) {
      case '1':
        icon = faSortUp;
        break;
      case '-1':
        icon = faSortDown;
        break;

      default:
        break;
    }
  }

  const handleClick = (): void => {
    const currentSearchParams = new URLSearchParams(window.location.search);

    if (sortByName === sortKey) {
      if (sortByOrder === '1') {
        currentSearchParams.set('sortByOrder', '-1');
      } else if (sortByOrder === '-1') {
        currentSearchParams.set('sortByOrder', '1');
      }
    } else {
      currentSearchParams.set('sortByName', sortKey);
      currentSearchParams.set('sortByOrder', sortType === 'number' ? '-1' : '1');
    }

    const updatedUrl = new URL(window.location.href);
    updatedUrl.search = currentSearchParams.toString();
    router.push(updatedUrl.toString());
  };

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer',
        gap: 0.5,
      }}
      onClick={handleClick}
    >
      {children}
      <Box maxWidth="content" sx={{ display: 'flex', alignItems: 'center' }}>
        <FontAwesomeIcon icon={icon} fontSize={12} color="gray" />
      </Box>
    </Box>
  );
}

export default SortWidget;
